module.exports = __webpack_public_path__ + "static/img/step 1.10f128a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step 1.gif
// module id = Js+E
// module chunks = 1